import { client } from '@api/client';
import type { CloseTracks, LocalTrackObject, TracksToPullObject } from '@api/types';
import { abortSignalTimeout } from '@api/utils';

export async function getStreamConfig(isStripChat?: boolean) {
    return client.GET('/streaming/broadcast/config/get', {
        params: {
            query: {
                isStripChat,
            },
        },
        signal: abortSignalTimeout(10_000),
    });
}

export async function regenerateStreamConfig(isStripChat?: boolean) {
    return client.GET('/streaming/broadcast/config/regenerate', {
        params: {
            query: {
                isStripChat,
            },
        },
        signal: abortSignalTimeout(10_000),
    });
}

export async function getCallBroadcastSession(offerSdp: string, tracks: LocalTrackObject[]) {
    return client.POST('/streaming/broadcast/call/config/new', {
        body: {
            offerSdp,
            tracks,
        },
    });
}

export async function callDeliveryConfig(tracks: TracksToPullObject[], sessionId?: string) {
    return client.POST('/streaming/delivery/call/config', {
        body: {
            sessionId,
            tracks,
        },
    });
}

export async function callDeliveryRenegotiate(sessionId: string, sdp: string) {
    return client.POST('/streaming/delivery/call/renegotiate', {
        body: {
            sdp,
            sessionId,
        },
    });
}

export async function callCloseTracks(body: CloseTracks, timeout = false) {
    return client.POST('/streaming/delivery/call/close', {
        body,
        signal: timeout ? abortSignalTimeout(5_000) : undefined,
    });
}

export async function ivsRealTimeGetBroadcastConfig() {
    return client.POST('/streaming/broadcast/ivs-realtime/config', {});
}

export async function ivsRealTimeRegenerateBroadcastConfig() {
    return client.POST('/streaming/broadcast/ivs-realtime/config/regen', {});
}

export async function ivsRealTimeGetDeliveryConfig(stageArn: string) {
    return client.POST('/streaming/delivery/ivs-realtime/config', {
        body: {
            stageArn,
        },
    });
}